import Keycloak from "keycloak-js";
import {
  ROLE_IMAGE_OWNER,
  ROLE_PATHOLOGIST,
  ROLE_RESEARCHER,
  ROLE_TESTER
} from "@/constants";

export const MODULE_AUTHENTICATION = "";
export const SET_KEYCLOAK = "SET_KEYCLOAK";
export const INIT_KEYCLOAK = "INIT_KEYCLOAK";

// const MODULE = "authentication/";
//
// const mutation_set_keycloak = MODULE + SET_KEYCLOAK;

const initOptions = {
  url: process.env.VUE_APP_KEYCLOAK_URL,
  realm: process.env.VUE_APP_KEYCLOAK_REALM,
  clientId: process.env.VUE_APP_KEYCLOAK_CLIENT_ID
};

const state = {
  keycloak: null
};

const getters = {
  token(state) {
    if (state.keycloak) {
      return state.keycloak.token;
    }
    return undefined;
  },
  tokenParsed(state) {
    if (state.keycloak) {
      return state.keycloak.tokenParsed;
    }
    return undefined;
  },
  roles(state) {
    if (state.keycloak) {
      return state.keycloak.tokenParsed.realm_access.roles;
    }
    return undefined;
  },
  isPathologist(state) {
    return state.keycloak.tokenParsed.realm_access.roles.includes(
      ROLE_PATHOLOGIST
    );
  },
  isResearcher(state) {
    return state.keycloak.tokenParsed.realm_access.roles.includes(
      ROLE_RESEARCHER
    );
  },
  isImageOwner(state) {
    return state.keycloak.tokenParsed.realm_access.roles.includes(
      ROLE_IMAGE_OWNER
    );
  },
  isTester(state) {
    return state.keycloak.tokenParsed.realm_access.roles.includes(
      ROLE_TESTER
    );
  }
};

const mutations = {
  [SET_KEYCLOAK](state, { keycloak }) {
    state.keycloak = keycloak;
  }
};

const actions = {
  [INIT_KEYCLOAK]({ commit }) {
    let keycloak = Keycloak(initOptions);
    return new Promise((resolve, reject) => {
      keycloak
        .init({ onLoad: "check-sso" })
        .then(authenticated => {
          console.log(keycloak.token);
          commit(SET_KEYCLOAK, { keycloak });
          resolve(authenticated);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  updateToken({ state }) {
    return new Promise((resolve, reject) => {
      state.keycloak
        .updateToken(30)
        .then(refreshed => {
          resolve(refreshed);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};
export default {
  namespaced: false,
  state,
  mutations,
  actions,
  getters
};
